<main class="main">
  <mat-dialog-content>
    <p>{{ 'dataIncomplete' | i18next }}</p>
    <p [innerHTML]="'infoNeed' | i18next"></p>
    <p>{{ 'goManageData' | i18next }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="main--btnContainer">
    <button
      type="button"
      class="main--btnContainer__btn btnCancel"
      mat-dialog-close
    >
      {{ 'notNow' | i18next }}
    </button>
    <button
      type="submit"
      class="main--btnContainer__btn btnConfirm btn confirm"
      (click)="goManageData()"
    >
      {{ 'yesUpdate' | i18next }}
    </button>
  </mat-dialog-actions>
</main>
